<template>
  <div class="files-content">
<!--    <div class='image-box'>-->
<!--      <img v-if="info.vip_rank > 0" src='static/images/bgImg-pro.svg' class='bgImg'></img>-->
<!--      <img v-else src="static/images/bgImg.png" class='bgImg'></img>-->
<!--    </div>-->
    <div class="content">
      <div class="body">
        <div v-if="info.expired_time<=0">
          <error :errorContent="'哎呀！分享的文件已经过期了'" :errorType="'delete'"></error>
        </div>
        <div v-if="error">
          <error :errorContent="errorMessage" :errorType="errorType || 'delete'"></error>
        </div>
        <div class="main-info" v-if="info.expired_time>0 && !error">
          <div class='-head' v-if="info.expired_time>0 && !error">
            <div class='-avatar'>
              <img :class="[info.vip_rank > 0 ? 'vip-avatar' : '']"
                   :src="user.head_pic ? user.head_pic : '/static/images/avatar.svg'"></img>
              <img v-if="data.info != null && data.info.vip_rank > 0" class="ic-pro"
                   src="/static/images/ic-pro.png"></img>
            </div>
            <div style="width: 100%">
              <div class='-title _text-overflow'>
                {{ user.usernick }} 向你分享
              </div>
              <div class='-meta'>
                {{ info.expired_time <= 0 ? '已过期' : info.expired_time + '天后过期' }}
                <div class="report" @click="fileReport">举报</div>
              </div>
            </div>
            <div>
              <el-popover
                placement="bottom"
                width="160"
                trigger="click">
                <div style="width: 100%; text-align: center">
                  <img :src="qrImg">
                  <p>{{ codeMsg }}</p>
                </div>
                <img slot="reference" class="qrcode" src="/static/images/qrcode.svg">
              </el-popover>
            </div>
          </div>

          <div class='-main' bindtap='detail' v-if="!error">
            <div class='-icon' v-if="info.type">
              <img :src='"/static/images/type/"+info.type+".svg"'></img>
            </div>
            <div class='-title'>
              {{ info.context != null ? info.context.Name : '' }}
            </div>
            <div class='-meta'>
              {{ info.context != null ? info.context.Length : '' }}
            </div>
          </div>
          <div class='tips' v-if="!error">获得链接的好友可查看</div>
          <div class='error' v-if="error">{{ errorMessage || '文件已过期' }}</div>
        </div>
      </div>

      <div class="new-button" v-if="info.expired_time>0 && !error">
        <div class='function-btn btn' @click="download">下载</div>
      </div>
    </div>
    <!--    <div :class="show==true ? 'block':'blocks'"></div>-->
    <div v-show="showWX" id="weixinTip" ref="weixin" class="wxtip" @click="hideWX">
      <img width="100%" src="/static/images/live_weixin.png">
    </div>

    <el-dialog
      title="举报原因"
      :visible.sync="showBanType"
      width="320px"
      center>
      <span>
        <div v-for="(item) in banTypeList">
          <el-radio class="ban-radio" v-model="selectBan" :label="item.ban_type">{{ item.type_name }}</el-radio>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
    <el-button class="confirm-btn" type="primary" round :loading="btnLoad" @click="confirmReport">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import {setCookie, getCookie, delCookie} from '../../utils/cookie'
import {shareFileInfo, getCloudpath, getBanType, submitBan} from '@/api/hardware'
import * as util from '../../utils/util'
import * as QR from '../../utils/weppQrcode'
import error from '@/components/errorPage'

export default {
  name: 'shareFilesDetail',
  components: {
    error,
  },
  data () {
    return {
      id: '',
      data: {},
      info: {},
      user: {},
      error: false,
      errorMessage: '',
      exeButton: false,
      isBindComputer: false,
      showBindComputerTips: false,
      showCover: false,
      qrImg: '',
      // isWeixin: false,
      showWX: false,
      codeMsg: '扫码在手机上下载',
      banTypeList: [],
      selectBan: '',
      showBanType: false,
      btnLoad: false,
      errorType: '',
    }
  },
  created () {
    this.id = this.$route.query.encryption_id
    if (this.IEVersion() != -1){
      this.error = true
      this.errorType = 'ie'
      this.errorMessage = "当前页面不支持IE11及以下浏览器访问，建议使用Chrome、Edge、Firefox等浏览器访问。"
      return ;
    }
    this.getFiles()
    // let ua = navigator.userAgent
    // this.isWeixin = !!/MicroMessenger/i.test(ua)
    if (this.isWeixin()) {
      this.codeMsg = '长按识别二维码'
    } else {
      this.codeMsg = '扫码在手机上下载'
    }
    // setCookie('token', 'abc123qwer')
    //console.log(this.IEVersion())
  },
  methods: {
    //举报
    fileReport () {
      // console.log(this.id)
      getBanType().then(res => {
        if (res.code == 100) {
          this.banTypeList = res.data
          this.showBanType = true
        }
      })
    },
    confirmReport () {
      // console.log(this.selectBan)
      this.btnLoad = true
      let data = {
        encryption_id: this.id,
        ban_type: this.selectBan
      }
      submitBan(data).then(res => {
        this.btnLoad = false
        if (res.code == 100) {
          this.showBanType = false
          this.$message({
            message: '举报成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    getFiles () {
      // var self = this;
      shareFileInfo(this.$route.query.encryption_id).then(data => {
        if (data.code === 100 && data.data) {
          data.data.info.context = JSON.parse(data.data.info.context)
          data.data.info.context.Size = data.data.info.context.Length
          data.data.info.context.Length = util.fs(data.data.info.context.Length)
          data.data.info.type = util.fileType(data.data.info.context.Extension)
          data.data.info.expired_time = util.gd(data.data.info.expired_time)
          // self.setData({
          //   data: data.data,
          //   error: false,
          // })
          this.data = data.data
          this.info = this.data.info
          this.user = this.data.user
          document.title = this.user.usernick + '向你分享了文件'
          this.error = false
          this.qrImg = QR.drawImg(window.location.href, {
            typeNumber: 4,
            errorCorrectLevel: 'M',
            size: 150
          })
          // if(data.data.info.vip_rank > 0){
          //   // 状态栏颜色
          //   wx.setNavigationBarColor({
          //     frontColor: '#ffffff', // 必写项
          //     backgroundColor: '#F0CB8D', // 必写项
          //   })
          // }
        } else {
          // wx.showToast({
          //   title: data.message,
          //   icon: 'none',
          //   mask: true
          // });
          // self.setData({
          this.error = true
          this.errorMessage = data.message
          // });
        }
      })
    },

    IEVersion () {
      var userAgent = navigator.userAgent //取得浏览器的userAgent字符串

      var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 //判断是否IE<11浏览器

      var isEdge = userAgent.indexOf('Edge') > -1 && !isIE //判断是否IE的Edge浏览器

      var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1

      if (isIE) {
        var reIE = new RegExp('MSIE (\\d+\\.\\d+);')

        reIE.test(userAgent)

        var fIEVersion = parseFloat(RegExp['$1'])

        if (fIEVersion == 7) {
          return 7

        } else if (fIEVersion == 8) {
          return 8

        } else if (fIEVersion == 9) {
          return 9

        } else if (fIEVersion == 10) {
          return 10

        } else {
          return 6//IE版本<=7

        }

      } else if (isEdge) {
        return 'edge'//edge

      } else if (isIE11) {
        return 11 //IE11

      } else {
        return -1//不是ie浏览器

      }

    },

    isWeixin () {
      // let ua = navigator.userAgent
      // return !!/MicroMessenger/i.test(ua) || !!/QQ/i.test(ua)
      var browser = navigator.userAgent.toLowerCase()
      if (browser.match(/MicroMessenger/i) == 'micromessenger') {
        //微信浏览器
        return true
      } else if (browser.indexOf(' qq') != -1 && browser.indexOf('mqqbrowser') != -1) {
        //qq内置浏览器
        return true
      } else if (browser.indexOf('mqqbrowser') != -1 && browser.indexOf(' qq') == -1) {
        //qq浏览器
        return false
      } else {
        return false
      }
    },

    download () {
      // if (this.isWeixin()) {
      //   this.showWX = true
      // } else {
        this.downFileApi()
      // }
    },
    downloadFile (name, src) {
      // const ele = document.createElement('a');
      // ele.setAttribute('href', url);
      // ele.setAttribute('download',name);
      // ele.style.display = 'none';
      // document.body.appendChild(ele);
      // ele.click();
      // document.body.removeChild(ele);

      let x = new XMLHttpRequest()
      x.open('GET', src, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        let url = window.URL.createObjectURL(x.response)
        let a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()
    },
    downFileApi () {
      getCloudpath(this.$route.query.encryption_id).then(res => {
        if (res.code == 100) {
          // var form = document.createElement('form');
          let baseUrl = ''
          if (res.data.service_provider == 'qcloud'){
            baseUrl = "https://cloud.hipcapi.com/"
          }else{
            if (res.data.cloud_path.indexOf("download") == 0){
              baseUrl = "https://g.hipccdn.com/"
            }else {
              baseUrl = "https://y.hipccdn.com/"
            }
          }
          let fileTop = res.data.cloud_path.substring(0, res.data.cloud_path.indexOf('?'))
          fileTop = encodeURIComponent(fileTop)
          let fileTail = res.data.cloud_path.substring(res.data.cloud_path.indexOf('?'))
          let filesUrl = baseUrl + fileTop + fileTail
          // this.downloadFile(this.info.context.Name, filesUrl)
          var form = document.createElement('form')
          form.action = filesUrl
          document.body.appendChild(form)
          form.submit()
          document.body.removeChild(form)
        }
      })
    },
    hideWX () {
      this.showWX = false
    }
  },
}
</script>

<style scoped>
page {
  background: #fafcff;
}

.files-content {
  /*max-width: 400px;*/
}

.frame {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
}

.back-home {
  /* height: 40px;
  width: 30px; */
  position: absolute;
  bottom: 0;
  right: 0px;
}

/* .back-home image {
  height: 30px;
  width: 30px;
  margin-top: 5px;
} */

.high-light {
  margin-top: 0;
  vertical-align: 2.5px;
}

.image-box {
  width: 100%;
}

.image-box .bgImg {
  width: 100%;
  max-width: 400px;
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.content {
  width: 100%;
  max-width: 400px;
  padding: 0 15px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 0;
  z-index: 10;
  /* overflow: scroll; */
  -webkit-overflow-scrolling: touch;
}

.header {
  width: 100%;
  height: 40px;
  color: #fff;
  margin: 20px 0 10px;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.header .my-device {
  font-size: 30px;
}

.header .lock-new {
  font-size: 14px;
  padding-top: 18px;
  box-sizing: border-box;
  width: 100px;
  text-align: right;
}

.body {
  width: 100%;
  margin-top: 20px;
  /* padding-bottom: 130px; */
}

.buttons {
  position: fixed;
  bottom: 20px;
  width: calc(95% - 30px);
  margin-left: 2.5%;
}

/* .buttons button{
position:absolute;
bottom:20px;
width:100%;
top:10px;
height:50px;
opacity:0;
} */

.cancle-btn {
  margin-top: 10px;
}

.body .main-info {
  width: 100%;
  padding: 20px 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  /* box-shadow:0px 2px 10px 0px rgba(184,192,204,0.4); */
  /*box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);*/
  position: relative;
}

::-webkit-scrollbar {
  display: none;
}

.body .main-info .-head {
  height: 40px;
  width: 100%;
  position: relative;
  display: flex;
}

.body .main-info .-head .-avatar {
  height: 40px;
  width: 40px;
  float: left;
  position: relative;
}

.body .main-info .-head img {
  height: 40px;
  width: 40px;
  float: left;
  border-radius: 20px;
  overflow: hidden;
}

.qrcode {
  border-radius: unset !important;
  height: 30px !important;
  width: 30px !important;
}

.vip-avatar {
  border: 1px solid #FFEFC2;
}

.body .main-info .-head .ic-pro {
  position: absolute;
  bottom: -2px;
  left: 5px;
  width: 30px !important;
  height: 15px !important;
}

.body .main-info .-head .-title {
  height: 20px;
  /*width: calc(100% - 50px);*/
  line-height: 20px;
  padding-left: 10px;
  float: left;
  margin-top: 2px;
  margin-bottom: 3px;
  font-size: 16px;
  word-wrap: break-word;
}

.body .main-info .-head .-meta {
  height: 15px;
  width: calc(100% - 50px);
  line-height: 15px;
  padding-left: 10px;
  float: left;
  font-size: 12px;
  color: rgba(196, 199, 204, 1);
  display: flex;
}

.body .main-info .-main {
  position: relative;
  text-align: center;
}

.body .main-info .-main .-icon img {
  height: 60px;
  width: 60px;
  display: inline-bloxk;
  margin-top: 50px;
  margin-bottom: 10px;
}

.body .main-info .-main .-title {
  /* height: 20px; */
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
}

.body .main-info .-main .-meta {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: rgba(196, 199, 204, 1);
  margin-bottom: 50px;
}

.-meta .report {
  margin-left: 12px;
  color: #3385ff;
  cursor: pointer;
}

.tips {
  font-size: 12px;
  text-align: center;
  color: rgba(196, 199, 204, 1);

}

.error {
  padding: 80px 0;
  text-align: center;
  font-size: 16px;
}

.frame {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
}

.device-detail {
  width: calc(100% - 40px);
  position: fixed;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  z-index: 110;
  padding: 30px 20px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 2px 10px 0px rgba(184, 192, 204, 0.4);
  /* box-shadow: 0 0 8px #B8C0CC;  */
}

.device-detail .detail-title {
  width: 100%;
  height: 32px;
  line-height: 32px;
  display: flex;
  justify-content: flex-start;
}

.device-detail .detail-title .device {
  width: 10%;
  height: 32px;
}

.device-detail .btn-function-container {
  height: 370px;
  overflow: auto;
}

.device-detail .detail-title .device-name {
  display: inline-block;
  width: 80%;
  /* padding-left: 6px; */
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: bold;
}

/*按钮*/
.footerContainer {
  background-color: #fff;
  text-align: center;
  display: inline-block;
  width: 100%;
  height: 120px;
}

.footerContainer .agree {
  background-color: #3385FF;
  height: 50px;
  line-height: 50px;
  color: #fff;
  border-radius: 25px;
  width: 100%;
  margin: 20px auto 13px;
  font-size: 16px;
  box-sizing: border-box;
}

.footerContainer .disagree {
  height: 50px;
  line-height: 50px;
  color: #313233;
  border-radius: 25px;
  width: 100%;
  margin: 20px auto 13px;
  font-size: 16px;
  border: 1px solid #C4C7CC;
  box-sizing: border-box;
}

/* 按钮 */
.new-button {
  padding: 20px 35px 0;
  box-sizing: border-box;
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
}

.function-btn {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #3385ff;
  color: #fff;
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
  border-radius: 50px;
  cursor: pointer;
}

.block {
  width: 100%;
  height: 400px;
  background-color: gray;
  /*background-image: url("/static/images/live_weixin.png");*/
  background-size: 100% 100%;

}

.blocks {
  width: 100%;
  height: 400px;
  background-color: gray;
  background-size: 100% 100%;
}

.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  /*display: none;*/
}

.wxtip-txt {
  margin-top: 107px;
  color: #fff;
  font-size: 20px;
  line-height: 1.8;
}

.ban-radio {
  font-size: 14px;
  margin: 5px 0;
}

.confirm-btn {
  width: 150px;
}

</style>



// WEBPACK FOOTER //
// src/view/hipc/ShareFilesDetail.vue